import { AppLanguage } from '../enums';

const displayNamesCache: Map<string, Intl.DisplayNames> = new Map<string, Intl.DisplayNames>();

const getDisplayNames = (lang: AppLanguage, type: 'region' | 'language'): Intl.DisplayNames => {
  const key: string = `${type}:${lang}`;
  let instance: Intl.DisplayNames | undefined = displayNamesCache.get(key);
  if (instance === undefined) {
    instance = new Intl.DisplayNames([lang], { type });
    displayNamesCache.set(key, instance);
  }
  return instance;
};

export const countryName = (code: string | null, lang: AppLanguage): string | null => {
  if (code === null || code === '') return null;
  try {
    return getDisplayNames(lang, 'region').of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
};

export const languageName = (code: string | null, lang: AppLanguage): string | null => {
  if (code === null || code === '') return null;
  try {
    return getDisplayNames(lang, 'language').of(code.toLowerCase()) ?? code;
  } catch {
    return code;
  }
};

export const platformLabel = (platform: string | null): string | null => {
  switch (platform) {
    case 'ios':
      return 'iOS';
    case 'android':
      return 'Android';
    case 'web':
      return 'Web';
    default:
      return null;
  }
};
